import { Fields } from 'models/Card'
import orm from 'models/orm'
import { createSelector as createOrmSelector } from 'redux-orm'

export const selectCards = createOrmSelector(
  orm,
  (state: any) => state.orm,
  (session: any): Fields[] => {
    return session.Card.all().toRefArray()
  }
)
